module.exports = __webpack_public_path__ + "6fc8b72661870ad3945ca82a026c78fd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/wizards-hut-empty.png
// module id = 336
// module chunks = 0